import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'

// v 2.0
// import '@mdi/font/css/materialdesignicons.css';
// Vue.use(Vuetify);
// export default new Vuetify({
//   icons: {
//     iconfont: 'mdi',
//   },
// });

// v 1.5
import 'vuetify/src/stylus/app.styl'
Vue.use(Vuetify, {
  iconfont: 'md',
  directives: {
    Ripple
  }
})